import { useRouter } from 'next/router'
import React, { FunctionComponent } from 'react'
import Button from './Button'

const UnderConstruction: FunctionComponent = (): JSX.Element => {
  const { push } = useRouter()
  return (
    <div className="text-center flex flex-col gap-6">
      <h2 className="text-2xl xl:text-4xl font-bold leading-8">
        Under Construction{' '}
        <span role="img" aria-label="roadwork sign">
          🚧
        </span>
      </h2>
      <Button className="w-fit mx-auto rounded-xl" onClick={() => push('/')}>
        Back to homepage
      </Button>
    </div>
  )
}

export default UnderConstruction
